import { unref as i } from "vue";
import { isArray as s } from "./index575.js";
const t = (r, n) => s(r) ? r.includes(n) : r === n, m = (r, n, e) => (o) => {
  t(i(r), n) && e(o);
};
export {
  t as isTriggerType,
  m as whenTrigger
};
